import { Pipe, PipeTransform } from '@angular/core';
import { FormControl } from '@angular/forms';
import { reminders } from './reminder.model';

@Pipe({
  name: 'reminderList'
})
export class ReminderListPipe implements PipeTransform {
  transform(previousReminderValue, currentControl: FormControl, questionnaireExpiry: number): any {
    const deepCopyReminders = [...reminders];
    const indexOfNumberOfDaysBeforeQuestionnaireExpiration = deepCopyReminders.findIndex(
      item => item.numberOfDays === questionnaireExpiry
    );

    if (indexOfNumberOfDaysBeforeQuestionnaireExpiration) {
      deepCopyReminders.splice(indexOfNumberOfDaysBeforeQuestionnaireExpiration);
    }

    if (previousReminderValue) {
      deepCopyReminders.findIndex;
      const indexOfReminderBefore = deepCopyReminders.findIndex(
        item => item.key === previousReminderValue
      );

      const indexOfCurrentReminder = deepCopyReminders.findIndex(
        item => item.key === currentControl.value
      );

      deepCopyReminders.splice(indexOfReminderBefore);

      if (indexOfCurrentReminder >= indexOfReminderBefore) {
        currentControl.setValue(null);
      }
    }

    return deepCopyReminders;
  }
}
